var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: _vm.buttonClassList,
      attrs: { type: "button", disabled: _vm.loading },
      on: { click: _vm.handleClick },
    },
    [
      _c(
        "ButtonLoading",
        { attrs: { loading: _vm.loading } },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }